"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOCATION_ENTITY_TYPE = exports.ENTITY_TYPE = exports.ESTABLISHED_PATIENT = exports.NEW_PATIENT = exports.LOGGING = void 0;
exports.LOGGING = {
    APPOINTMENT_INFO_CHANGED: 'user_action.appointment_info.changed',
    TIMESLOT_CLICKED: 'user_action.availability_tiles.time_slot.click',
    VIEW_ALL_APPOINTMENTS_CLICKED: 'user_action.availability_tiles.view_all_appointments.click',
    LOCATION_FILTER: 'user_action.appointment_info.location_filter.changed'
};
exports.NEW_PATIENT = 'new';
exports.ESTABLISHED_PATIENT = 'established';
exports.ENTITY_TYPE = 'entity_type';
exports.LOCATION_ENTITY_TYPE = 'location';
//# sourceMappingURL=constants.js.map